import React from 'react';
import '../../styles/ui/SkeletonLoader.css';

export function SkeletonCard() {
  return (
    <div className="skeleton-card" aria-hidden="true">
      <div className="skeleton skeleton-avatar" />
      <div className="skeleton-lines">
        <div className="skeleton skeleton-line skeleton-line-lg" />
        <div className="skeleton skeleton-line skeleton-line-sm" />
      </div>
    </div>
  );
}

export function SkeletonGrid({ count = 4 }) {
  return (
    <div className="skeleton-grid" aria-busy="true" aria-label="جاري التحميل">
      {Array.from({ length: count }, (_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export function SkeletonProfile() {
  return (
    <div className="skeleton-profile" aria-hidden="true">
      <div className="skeleton skeleton-profile-logo" />
      <div className="skeleton-lines">
        <div className="skeleton skeleton-line skeleton-line-lg" />
        <div className="skeleton skeleton-line" />
        <div className="skeleton skeleton-line skeleton-line-sm" />
      </div>
    </div>
  );
}

export default SkeletonGrid;
